export default "__VITE_ASSET__BNFYBIJE__"